<div class="doNotPrint">
	<div class="p-3 d-flex align-items-center gap-3">
		<div class="form-floating">
			<input type="text" class="form-control w-auto" id="ref" placeholder="ref" [(ngModel)]="ref" />
			<label for="ref">Reference No.</label>
		</div>
		<div class="form-floating">
			<input type="number" step="0.01" required class="form-control w-auto" id="loanAmount" placeholder="loanAmount" [(ngModel)]="loanAmount" min="0" (keypress)="sharedService.isNumberKey($event)" />
			<label for="loanAmount">Extra Settlement Amount*</label>
		</div>
		@if (sharedService.isBossAccount()) {
			<div class="vr mx-3"></div>
			<div class="form-floating">
				<input type="number" step="0.01" required class="form-control w-auto" id="settlementBalance" placeholder="settlementBalance" [(ngModel)]="settlement" min="0" (keypress)="sharedService.isNumberKey($event)" />
				<label for="settlementBalance">Settlement Balance*</label>
			</div>
			On
			<mat-form-field class="col-12 col-md-2" subscriptSizing="dynamic">
				<mat-label>Last Extra Date</mat-label>
				<input matInput readonly [matDatepicker]="latestDatePicker" name="latestDate" [(ngModel)]="latestDate" required (change)="resetReady()" [disabled]="isAll" [max]="sharedService.getTodayDate()" />
				<mat-datepicker-toggle matSuffix [for]="latestDatePicker"></mat-datepicker-toggle>
				<mat-datepicker #latestDatePicker name="latestDate"></mat-datepicker>
			</mat-form-field>
			<div class="vr mx-3"></div>
			<mat-form-field class="col-12 col-md-2" subscriptSizing="dynamic">
				<mat-label>Print Date</mat-label>
				<input matInput readonly [matDatepicker]="printDatePicker" name="printDate" [(ngModel)]="printDate" required (change)="resetReady()" [disabled]="isAll" [max]="sharedService.getTodayDate()" />
				<mat-datepicker-toggle matSuffix [for]="printDatePicker"></mat-datepicker-toggle>
				<mat-datepicker #printDatePicker name="printDate"></mat-datepicker>
			</mat-form-field>
		}
		@if (loanAmount != null && settlement != null) {
			<button class="btn btn-primary" (click)="print()">Print</button>
			@if (signLink != undefined) {
				<button class="btn btn-dark d-block" (click)="copySignLink(signLink)"><i class="fas fa-link"></i> Sign Link</button>
			} @else {
				<button class="btn btn-info" (click)="createSignLink()"><i class="fas fa-link"></i> Create Link</button>
			}
		}

		@if (dsList.length > 0) {
			<div class="vr mx-3"></div>
			<button class="btn btn-outline-dark ms-1" #tooltip="matTooltip" matTooltip="View Signing History" matTooltipPosition="above" matTooltipHideDelay="100" matTooltipClass="tooltip-black" (click)="openViewDocusealHistory()">
				<i class="fas fa-history"></i>
			</button>
		}
	</div>
	<hr />
</div>

@if (selectedCustomer != undefined && selectedCompany != undefined && loanAmount != undefined && settlement != undefined && simpan != undefined) {
	<div class="text-justify settlementBreakdownLetter print-area" style="font-family: 'Calibri, sans-serif'; line-height: 120%; font-size: 12pt" id="htmlData" #htmlData>
		<h3 class="text-center">
			<strong> {{ selectedCompany.Name }}</strong>
		</h3>
		<div class="text-center">
			<strong> ({{ selectedCompany.RegNum }})</strong>
		</div>
		<div class="text-center">
			<strong> {{ selectedCompany.Address }}</strong>
		</div>
		<div class="text-center">
			<strong> TEL: {{ selectedCompany.ContactNo }}</strong>
		</div>
		<p class="d-flex justify-content-end">Tarikh : {{ printDate | date: 'dd-MM-yyyy' }}</p>
		<h5 class="text-center text-decoration-underline"><strong> PENYATA PENYELESAIAN PINJAMAN</strong></h5>
		<table class="table table-sm table-borderless cust-table px-5">
			<tbody>
				<tr>
					<td><strong>NAMA</strong></td>
					<td>:</td>
					<td>
						<strong>{{ selectedCustomer.Name }}</strong>
					</td>
				</tr>
				<tr>
					<td><strong>NO. KAD PENGENALAN</strong></td>
					<td>:</td>
					<td>
						<strong>{{ selectedCustomer.ICNumberWithDash }}</strong>
					</td>
				</tr>
				<tr>
					<td><strong>NO RUJUKAN</strong></td>
					<td>:</td>
					<td>
						<strong>{{ ref }}</strong>
					</td>
				</tr>
			</tbody>
		</table>
		<p>
			Untuk makluman tuan/puan, di bawah ini dinyatakan jumlah yang perlu dibayar untuk menjelaskan akaun di atas dengan mengikut syarat-syarat yang sudah dibincang dengan pihak <strong>{{ selectedCompany.Name }}</strong>
		</p>
		<table class="table table-borderless mb-0 px-5 breakdownTable">
			<tbody>
				<tr>
					<td>(+)</td>
					<td>Baki pada {{ latestDate | date: 'dd-MM-yyyy' }}</td>
					<td>:</td>
					<td>
						RM
						@if (settlement == 0) {
							{{ loanAmount | number: '1.2-2' }}
						} @else {
							{{ settlement | number: '1.2-2' }}
						}
					</td>
				</tr>
				<tr>
					<td></td>
					<td>Ansuran tertunggak</td>
					<td>:</td>
					<td></td>
				</tr>
				<tr>
					<td>(-)</td>
					<td>Payment</td>
					<td>:</td>
					<td>RM {{ simpan | number: '1.2-2' }}</td>
				</tr>
				<tr>
					<td>(+)</td>
					<td class="text-danger">EXTRA</td>
					<td>:</td>
					<td class="text-danger">
						RM
						@if (settlement == 0) {
							0.00
						} @else {
							{{ loanAmount | number: '1.2-2' }}
						}
					</td>
				</tr>
			</tbody>
			<tfoot>
				<tr>
					<td></td>
					<td>Jumlah Penyelesaian</td>
					<td>:</td>
					<td>RM {{ calculateBalance() | number: '1.2-2' }}</td>
				</tr>
			</tfoot>
		</table>
		<br />
		<p>
			Jumlah penyelesaian di atas perlu dibayar sebelum atau pada {{ getLatestSettlementDate() | date: 'dd-MM-yyyy' }}. Sekiranya tuan/puan gagal membuat demikian, jumlah tersebut akan dibatal dan jumlah baru akan dikira sekiranya tuan/puan bercadang untuk menjelaskan pinjaman
			tersebut selepas tarikh yang dinyatakan di atas. Diskaun semasa penyelesaian loan juga adalah tidak dibenarkan.
		</p>
		<br />
		<p>
			<strong>SEMUA BAYARAN HARUS "ONLINE TRANSFER / OVER THE BANK KAUNTER" KE AKAUN BANK SYARIKAT SAHAJA. INI ADALAH UNTUK SYARIKAT MENJEJAK BAYARAN BALIK YANG TELAH DIBUAT OLEH ANDA MELALUI TRANSAKSI BANK.</strong>
		</p>
		<p>NOTE : CASH / ATM CASH DEPOSIT ADALAH TIDAK DITERIMA.</p>
		<div class="flex-container">
			<div class="flex-item">
				<div>
					<strong>{{ selectedCompany.Name }}</strong>
				</div>
				<div>
					<strong>({{ selectedCompany.RegNum }})</strong>
				</div>
				<div class="signature-area"></div>
				<div><strong>AUTHORISED BY</strong></div>
			</div>
			<div class="flex-item">
				<div>
					<strong>NAMA : {{ selectedCustomer.Name }}</strong>
				</div>
				<div>
					<strong>NO K/P: {{ selectedCustomer.ICNumberWithDash }}</strong>
				</div>
				<div class="signature-area"></div>
				<div><strong>TANDATANGAN PEMINJAM</strong></div>
			</div>
		</div>
	</div>
}
